import React, { useEffect } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation
} from "react-router-dom";
import { SnackbarProvider } from "../src/constant/SnackbarProvider";
import LoadingComponent from "./component/LoadingComponent";
import { GlobalDataProvider } from "./constant/GlobalDataContext";
import { LoadingProvider } from "./constant/LoadingContext";
import { isIpad } from "./constant/StaffOnboardState";
import SignedDocument from "./view/documents/SignedDocument";
import UnsignDocument from "./view/documents/UnsignDocument";
import LinkingPage from "./view/LinkingPage";
import LoginPage from "./view/LoginPage";
import MainPage from "./view/MainPage";
import MainPagePad from "./view/MainPagePad";
import StaffInfoFormSigned from "./view/StaffInfoFormSigned";
import StaffInfoFormUnsigned from "./view/StaffInfoFormUnsigned";
import StaffPersonalInfoForm from "./view/StaffPersonalInfoForm";
import StaffTable from "./view/StaffTable";
import ThankYouPage from "./view/ThankYouPage";

const App = () => {
  
  const PrivateRoute = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem("user");
    const location = useLocation();

    useEffect(() => {
      if(!isIpad()) {
        return ;
      }
      // Initial state push
      window.history.pushState(null, '', window.location.pathname);
  
      const handlePopState = () => {
        // Immediately push state and go forward when back button is clicked
        window.history.pushState(null, '', window.location.pathname);
        window.history.forward();
        
        // Add another state as backup
        setTimeout(() => {
          window.history.pushState(null, '', window.location.pathname);
        }, 0);
      };
  
      // Handle both click events and keyboard navigation
      window.addEventListener('popstate', handlePopState, true);
      
      // Additional protection for rapid clicks
      const interval = setInterval(() => {
        window.history.pushState(null, '', window.location.pathname);
      }, 200);
  
      return () => {
        window.removeEventListener('popstate', handlePopState, true);
        clearInterval(interval);
      };
    }, []);

    if (!isAuthenticated) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (location.pathname === "/") {
      location.pathname = "/main";
    }

    if (isIpad()) {
      if (location.pathname.includes("/p/")) {
        return children;
      }
      return <Navigate to={`/p${location.pathname}`} replace />;
    } else {
      if (location.pathname.includes("/p/")) {
        return <Navigate to={location.pathname.replace("/p", "")} replace />;
      }
      return children;
    }
  };


  useEffect(() => {
    document.title = "員工文件";
  }, []);

  return (
    <SnackbarProvider>
      <GlobalDataProvider>
        <LoadingProvider>
          <Router>
            <LoadingComponent />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/main"
                element={
                  <PrivateRoute>
                    <MainPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/p/main"
                element={
                  <PrivateRoute>
                    <MainPagePad />
                  </PrivateRoute>
                }
              />
              <Route
                path="/main/linking"
                element={
                  <PrivateRoute>
                    <LinkingPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/main/staffTable"
                element={
                  <PrivateRoute>
                    <StaffTable />
                  </PrivateRoute>
                }
              />
              <Route
                path="/main/documentLists"
                element={
                  <PrivateRoute>
                    <SignedDocument />
                  </PrivateRoute>
                }
              />
              <Route
                path="/p/main/documentLists"
                element={
                  <PrivateRoute>
                    <UnsignDocument />
                  </PrivateRoute>
                }
              />

              <Route
                path="/staffInfoFormSigned"
                element={
                  <PrivateRoute>
                    <StaffInfoFormSigned />
                  </PrivateRoute>
                }
              />
              <Route
                path="/p/staffInfoFormUnsigned"
                element={
                  <PrivateRoute>
                    <StaffInfoFormUnsigned />
                  </PrivateRoute>
                }
              />
              <Route path="/thankYou" element={<ThankYouPage />} />
              <Route
                path="/staffSubmitForm"
                element={<StaffPersonalInfoForm />}
              />
              <Route path="*" element={<Navigate to={`/main`} replace />} />
            </Routes>
          </Router>
        </LoadingProvider>
      </GlobalDataProvider>
    </SnackbarProvider>
  );
};

export default App;
